<template>
  <div @paste="handlePaste">
    <div>
      <myUpLoad
        style="float: left"
        v-if="status == 0"
        :multiple="true"
        :asImage="getAsImage(type)"
        :fieldName="'myUploadTable'"
        :uplaodModel="uplaodModel"
        @handleAvatarSuccess="uploadSuccess"
      ></myUpLoad>
      <el-button
        style="float: left; margin-left: 10px"
        type="primary"
        size="small"
        :loading="loading"
        @click="batchDownload()"
        >批量下载</el-button
      >
      <div style="clear: both"></div>
    </div>
    <el-table
      :data="list"
      style="width: 100%; margin-top: 10px"
      :height="height"
      :max-height="maxHeight"
      :row-class-name="tableRowClassName"
      @row-dblclick="(row, column, event) => updateDataClick(row.index)"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" align="center" width="55"> </el-table-column>
      <el-table-column label="序号" align="center" width="60">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="type == 1" label="图片显示" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 50px"
            :src="url + scope.row.url"
            :preview-src-list="[url + scope.row.url]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column v-if="type == 1" label="图片名称" prop="name" align="center">
      </el-table-column>
      <el-table-column v-if="type == 2" label="文件显示" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="imageInit(scope.row.url)"
            style="height: 50px"
            :src="url + scope.row.url"
            :preview-src-list="[url + scope.row.url]"
          >
          </el-image>
          <i v-else class="el-icon-document"></i>
        </template>
      </el-table-column>
      <el-table-column v-if="type == 2" label="文件名称" align="center">
        <template slot-scope="scope">
          <el-input
            v-if="status == 0 && btnStaus.show === true && btnStaus.index == scope.$index"
            v-model="scope.row.name"
            @blur="saveDataClick"
          ></el-input>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="type == 3" label="文件名称" align="center">
        <template slot-scope="scope">
          <el-input
            v-if="status == 0 && btnStaus.show === true && btnStaus.index == scope.$index"
            v-model="scope.row.name"
            @blur="saveDataClick"
          ></el-input>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="type != 1" label="上传时间" prop="createTime" align="center">
      </el-table-column>
      <el-table-column v-if="type != 1" label="上传人" prop="createName" align="center">
      </el-table-column>
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openFile(scope.row)"
            >下载</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="previewFile(scope.row, scope.$index)"
            >打开文件</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="saveDataClick"
            v-if="status == 0 && btnStaus.show === true && btnStaus.index == scope.$index"
            >保存</el-button
          >
          <div v-if="status == 0" style="margin-top: 10px">
            <el-button
              size="mini"
              type="danger"
              v-if="status == 0"
              @click="uploadDelete(scope.row, scope.$index)"
              >删除</el-button
            >
            <el-button
              size="mini"
              type="primary"
              v-if="
                status == 0 && (btnStaus.show === false || btnStaus.index != scope.$index)
              "
              @click="updateDataClick(scope.$index)"
              >修改名称</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import projectConfig from "@/core/config";
import { getCurrentTime } from "@/utils/myUtils";
import { download_download } from "@/api/myController/system";
import axios from "axios";
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  props: {
    height: {
      type: Number,
      default: undefined,
    },
    maxHeight: {
      type: Number,
      default: undefined,
    },
    // 上传模块
    uplaodModel: {
      type: Object,
      default: "文件",
    },
    // 传过来什么值返回出去什么值，相当于KEY
    markIndex: {
      type: Number,
      default: 0,
    },
    // 1.图片，2.图纸，3.附件
    type: {
      type: Number,
      default: 1,
    },
    // 0.可编辑，1.只可查看
    status: {
      type: Number,
      default: 0,
    },
    // 展示数据
    list: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      url: projectConfig.imageBaseUrl, // 显示图纸路径 //后台路径
      btnStaus: {
        show: false,
        index: null,
      }, //0.正常显示，1.改成保存
      multipleSelection: [],
      loading: false,
    };
  },
  created() {},
  methods: {
    handlePaste() {
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          const blob = items[i].getAsFile();
          this.uploadFile(blob);
        }
      }
    },
    uploadFile(file) {
      // 在这里实现文件上传的逻辑，例如使用axios发送POST请求等。
      console.log("File to upload:", file);
    },
    getAsImage(data) {
      switch (data) {
        case 1:
          return true;
        case 2:
          return false;
        case 3:
          return false;
        default:
          break;
      }
    },
    // 相关附件
    imageInit(test_str) {
      if (!test_str) {
        return;
      }
      var index = test_str.lastIndexOf("."); // 获取指定字符串最后一次出现的位置，返回index
      var str = test_str.substr(index + 1); // substr(start, length) 抽取从start下标开始的length个字符，返回新的字符串
      return this.isImageType(str);
    },
    isImageType(str) {
      // toLowerCase() 将字符串转换为小写，返回一个新的字符串
      return (
        ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tiff"].indexOf(
          str.toLowerCase()
        ) !== -1
      );
    },
    uploadSuccess(res, file) {
      let json = {
        fileInfoId: res.data.fileInfoId,
        name: file.name,
        url: res.data.uploadPath + res.data.filename,
        createTime: getCurrentTime(),
        createName: this.getUserInfo.showName,
      };
      if (this.list == null || this.list == "") {
        this.list = [json];
      } else {
        this.list.push(json);
      }

      this.$emit("uploadSuccess", this.list, this.type, this.markIndex);
    },
    uploadDelete(row, index) {
      this.list.splice(index, 1);
      this.$emit("uploadDelete", this.list, this.type, this.markIndex);
    },
    openFile(row) {
      try {
        if (row.name) {
          this.onDownFile(this.url + row.url, row.name);
        } else {
          window.open(this.url + row.url);
        }
      } catch (error) {
        window.open(this.url + row.url);
      }
      // window.open(this.url + row.url);
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    //
    updateDataClick(index) {
      this.btnStaus = {
        show: true,
        index: index,
      }; //0.正常显示，1.改成保存
    },
    // 点击保存按钮
    saveDataClick() {
      this.btnStaus = {
        show: false,
        index: null,
      }; //0.正常显示，1.改成保存
      this.$emit("uploadSuccess", this.list, this.type, this.markIndex);
    },
    onDownFile(url, filename) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, filename);
      });
    },

    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },

    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },
    // 可预览文件
    // excel
    excelInit(test_str) {
      var index = test_str.lastIndexOf("."); // 获取指定字符串最后一次出现的位置，返回index
      var str = test_str.substr(index + 1); // substr(start, length) 抽取从start下标开始的length个字符，返回新的字符串
      return this.isExcelType(str);
    },
    isExcelType(str) {
      // toLowerCase() 将字符串转换为小写，返回一个新的字符串
      return ["xls", "xlsx", "csv"].indexOf(str.toLowerCase()) !== -1;
    },
    // word
    wordInit(test_str) {
      var index = test_str.lastIndexOf("."); // 获取指定字符串最后一次出现的位置，返回index
      var str = test_str.substr(index + 1); // substr(start, length) 抽取从start下标开始的length个字符，返回新的字符串
      return this.isWordType(str);
    },
    isWordType(str) {
      // toLowerCase() 将字符串转换为小写，返回一个新的字符串
      return ["doc", "docx"].indexOf(str.toLowerCase()) !== -1;
    },
    // pdf
    pdfInit(test_str) {
      var index = test_str.lastIndexOf("."); // 获取指定字符串最后一次出现的位置，返回index
      var str = test_str.substr(index + 1); // substr(start, length) 抽取从start下标开始的length个字符，返回新的字符串
      return this.isPdfType(str);
    },
    isPdfType(str) {
      // toLowerCase() 将字符串转换为小写，返回一个新的字符串
      return ["pdf", "ofd"].indexOf(str.toLowerCase()) !== -1;
    },
    // ppt
    pptInit(test_str) {
      var index = test_str.lastIndexOf("."); // 获取指定字符串最后一次出现的位置，返回index
      var str = test_str.substr(index + 1); // substr(start, length) 抽取从start下标开始的length个字符，返回新的字符串
      return this.isPptType(str);
    },
    isPptType(str) {
      // toLowerCase() 将字符串转换为小写，返回一个新的字符串
      return (
        ["ppt", "pptx", "pps", "ppsx", "ppa", "ppam"].indexOf(str.toLowerCase()) !== -1
      );
    },
    // 图片
    imgInit(test_str) {
      var index = test_str.lastIndexOf("."); // 获取指定字符串最后一次出现的位置，返回index
      var str = test_str.substr(index + 1); // substr(start, length) 抽取从start下标开始的length个字符，返回新的字符串
      return this.isImgType(str);
    },
    isImgType(str) {
      // toLowerCase() 将字符串转换为小写，返回一个新的字符串
      return (
        ["jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "git"].indexOf(
          str.toLowerCase()
        ) !== -1
      );
    },
    // 预览
    previewFile(row, index) {
      if (!row.fileInfoId) {
        this.$message.error("该文件暂不支持预览！");
        return;
      }
      // 判断是否是图片
      if (this.imgInit(row.name)) {
        let imageUrl = this.url + row.url;
        window.open(imageUrl, "_blank");
        return;
      }
      let type = "s";
      if (this.excelInit(row.name)) {
        type = "s";
      } else if (this.wordInit(row.name)) {
        type = "w";
      } else if (this.pdfInit(row.name)) {
        type = "f";
      } else if (this.pptInit(row.name)) {
        type = "p";
      } else {
        this.$message.error("该文件暂不支持预览！");
        return;
      }
      const { href } = this.$router.resolve({
        path: "/excelEditV2",
        query: {
          value: row.fileInfoId,
          officeType: type,
        },
      });
      window.open(href);
      // this.$emit("previewFile", row, index);
    },
    // 批量下载
    //将链接转化为arraybuffer文件流格式
    getFile(url) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url,
          responseType: "arraybuffer",
        })
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error.toString());
          });
      });
    },
    //下载图片
    downloadPic(urlList) {
      this.loading = true;
      const zip = new JSZip();
      const promises = [];
      //将文件添加到压缩包中
      urlList.forEach((url, index) => {
        const promise = this.getFile(url).then((data) => {
          //截取后缀名（注意重命名一定要加上原来图片的后缀，否则下载出来的文件就是错误的）
          let nameList = url.split(".");
          let fileName = index + "." + nameList[nameList.length - 1];
          zip.file(fileName, data, { binary: true }); //文件名、文件流、是否为二进制
        });
        promises.push(promise);
      });
      //等待所有文件添加完进行打包
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            //利用file-saver保存文件  自定义文件名
            FileSaver.saveAs(content, new Date().getTime());
            this.loading = false;
          });
        })
        .catch((err) => {
          this.$message.error(err || "文件压缩失败");
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDownload() {
      let fileUrlList = [];
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((item) => {
          fileUrlList.push(this.url + item.url);
        });
      } else {
        this.list.forEach((item) => {
          fileUrlList.push(this.url + item.url);
        });
      }
      this.downloadPic(fileUrlList);
      return;
      let json = {
        fileUrlList,
      };
      download_download(json).then((res) => {
        this.$message.success("操作成功！");
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
